import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useEffect, useState } from 'react';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import PlusIcon from "../../images/circle plus.svg";
import WizardSideBarStep from '../../models/WizardSideBarStep';
import './wizard-sidebar.css';
import Tooltip from "../Tooltip/Tooltip";

type Props = {
    masterImages?: any
    isExpanded: boolean,
    step: number,
    steps: WizardSideBarStep[],
    onSelectedImage?: any
    onSetPrimary?: any
}

type StepMap = {
    stepIndex: number,
    substepIndex: number | undefined
}

const WizardSideBar: FC<Props> = ({ isExpanded, step, steps = [], masterImages, onSelectedImage, onSetPrimary }) => {
    const [stepTree, setstepTree] = useState<StepMap[]>([]);
    const [selectedImage, setSelectedImage] = useState(1)
    const { translate } = useLocale();

    const createStepTree = (steps): void => {
        const newSteps: StepMap[] = steps.flatMap((step, i) => {
            // Create an array with the step itself and its substeps (if any)
            const stepEntry: StepMap = { stepIndex: i, substepIndex: undefined };
            const substepsEntries: StepMap[] = step.substeps?.map((_, j) => ({
                stepIndex: i,
                substepIndex: j
            })) || [];

            return [stepEntry, ...substepsEntries];
        });

        setstepTree(newSteps);
    }

    useEffect(() => {
        createStepTree(steps);
    }, [steps])

    const mapStep = (step) => {
        return stepTree[step]?.stepIndex;
    }
    const handleSelectedImage = (item) => {

        setSelectedImage(item.id)
        onSelectedImage(item)
    }

    const mapSubStep = (step) => {
        return stepTree[step]?.substepIndex ?
            stepTree[step]?.substepIndex as number :
            0;
    }

    const PlaceholderIcon = (item, id) =>
        <a href="#">
            <img className={`h-24  rounded-full ${selectedImage === id ? ' border-2 border-portal-blue-primary' : null} `} onClick={() => handleSelectedImage(item)} src={PlusIcon} alt="" />
        </a>
    const MasterImage = (item, id) =>
        <div className="h-24 w-24 rounded-full  text-gray-400 ">
            <a href="#">
                <img className={`rounded-full w-full h-full object-contain  ${selectedImage === id ? ' border-2 border-portal-blue-primary' : null} `} onClick={() => handleSelectedImage(item)} src={`data:image/png;base64,${item.image}`} alt="" />
            </a>
        </div>

    const buildTree = () => {
        let subStepCounter = 0;
        return steps.map((item, index) => {
            return <li key={`li-${index}`} >
                <div className="flex flex-col ml-2 mr-4">
                    <div className="py-4 justify-start items-center flex flex-row">
                        {index < steps.length - 1 || item.substeps.length !== 0 ?
                            <div className={`z-0 absolute ml-4-5 mt-10 h-16 border-r-2 border-solid ${getPreLinkClass(index, mapStep(step), mapSubStep(step))} `} /> :
                            undefined}
                        {index > 0 ?
                            <div className={`z-0 absolute ml-4-5 -mt-10 h-12 border-r-2 border-solid ${getPostLinkClass(index, mapStep(step))}`} /> :
                            undefined}
                        <div className={`z-10 w-10 h-10 rounded-full wizard-side-bar-grey border-8 ${index < mapStep(step) ? 'completed-step' : index > mapStep(step) ? 'pending-step' : 'bg-portal-blue-primary'}`}
                            style={{ minWidth: "2.5rem" }}>
                            {index < mapStep(step) ?
                                <FontAwesomeIcon className="mt-1 ml-1 text-white" icon={faCheck} transform="shrink-2" /> :
                                undefined}
                        </div>
                        <div className="flex flex-col ml-2 w-40 overflow-hidden break-words">
                            <label className={`text-lg font-semibold ${isExpanded ? '' : 'hidden'}`}>{item.title}</label>
                            <label className={`text-sm text-gray-600 ${isExpanded ? '' : 'hidden'}`} >{(item.description && item.description.length > 0) ? item.description.split('\n')[0] : (index > mapStep(step) ? translate.byKey(TranslationKeys.pending) : '')}</label>
                            {
                                item.description && item.description.includes('\n') ?
                                    <label className={`text-sm text-gray-600 ${isExpanded ? '' : 'hidden'}`} >
                                        {
                                            // item.description.split('\n')[1] === '...' ?
                                            //     <Tooltip text={item.toolTipDescription ?? ''} direction='top-preset' contentPositionX='start' show={item.showToolTip ?? false}>
                                            //         <span >{item.description.split('\n')[1]}</span>
                                            //     </Tooltip> :
                                                item.description.split('\n').length >= 2 ? item.description.split('\n')[1] : item.description
                                        }
                                    </label>
                                    : null
                            }
                        </div>
                    </div>
                    {item.substeps.map((subitem, subindex) => {
                        subStepCounter++;
                        return <div key={subindex} className="flex flex-row">
                            <div className={`ml-4-5 border-r-2 ${getSubstepLinkClass(index, mapStep(step), subindex, mapSubStep(step))} `} />
                            <div className={`mt-3 h-0 w-6 border-t-2 ${getSubstepLinkClass(index, mapStep(step), subindex, mapSubStep(step))}`} />
                            <div className="align-middle">
                                <div className={`mt-1 w-4 h-4 rounded-full ${getSubstepClass(index, mapStep(step), subindex, mapSubStep(step))}`} />
                            </div>
                            <label className={`ml-3 text-base ${isExpanded ? '' : 'hidden'}`}>{subitem.title}</label>
                        </div>
                    })}
                </div>
            </li>
        })
    }

    return <>
        {masterImages ?
            <div className={`flex flex-col wizard-side-bar min-w-96`} style={{ minWidth: '180px' }}>
                <ul className="divide-y divide-gray-200 mx-10 w-96">
                    <li className="py-5 flex">
                        {masterImages?.image1?.image ? MasterImage(masterImages.image1, 1) : PlaceholderIcon(masterImages.image1, 1)}
                    </li>
                    <li className="py-5 flex">
                        {masterImages?.image2?.image ? MasterImage(masterImages.image2, 2) : PlaceholderIcon(masterImages.image2, 2)}
                    </li>
                    <li className={`py-5  `} >
                        {masterImages?.image3?.image ? MasterImage(masterImages.image3, 3) : PlaceholderIcon(masterImages.image3, 3)}
                    </li>
                </ul>
            </div> :
            <div className={`flex flex-col wizard-side-bar`} style={steps.length > 0 ? { minWidth: '12rem', maxHeight: 517 } : {}}>
                <ul>{buildTree()}</ul>
            </div>}
    </>;
}

export default WizardSideBar;

function getPostLinkClass(index: number, step: number) {
    return index < step ? 'completed-step-link' : index > step ? 'pending-step-link' : 'completed-step-link';
}

function getPreLinkClass(index: number, step: number, substep: number) {
    return index < step ? 'completed-step-link' : index > step ? 'pending-step-link' : substep > 0 ? 'completed-step-link' : 'border-portal-blue-primary';
}

function getSubstepClass(index: number, step: number, subindex: number, substep: number) {
    return index < step ? 'completed-step' :
        index > step ? 'pending-step' :
            subindex < substep ? 'completed-step' :
                subindex > substep ? 'pending-step' : 'current-step';
}

function getSubstepLinkClass(index: number, step: number, subindex: number, substep: number) {
    return index < step ? 'completed-step-link' :
        index > step ? 'pending-step-link' :
            subindex < substep ? 'completed-step-link' :
                subindex > substep ? 'pending-step-link' : 'current-step-link';
}
